import Dashboard from './components/Dashboard.vue';
import Layout from './components/Layout.vue';
import auth from '../authentication/services/auth';
import Registrations from './components/Registrations.vue';
import RegistrationDetails from './components/RegistrationsDetails.vue';
import UsageDetails from './components/UsageDetails.vue';
import EmailPreviewDetails from './components/EmailPreviewDetails.vue';

function requireAuth(to, from, next) {
    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else {
        next();
    }
}

const routes = [
    {
        path: '/support',
        component: Layout,
        beforeEnter: requireAuth,
        children: [
            {
                path: '',
                component: Dashboard,
                name: 'Dashboard',
                children: [
                    { path: 'errors', component: Registrations, name: 'RegistrationErrors' },
                    { path: 'pending', component: Registrations, name: 'RegistrationPendings' },
                    { path: 'inprogress', component: Registrations, name: 'RegistrationInProgress' },
                    { path: 'finished', component: Registrations, name: 'RegistrationFinished' },
                    { path: 'duplicates', component: Registrations, name: 'RegistrationDuplicates' },
                    { path: 'registration/:id', component: RegistrationDetails, name: 'RegistrationDetails' },
                    { path: 'usage', component: UsageDetails, name: 'Usage' },
                    { path: 'usage/:instance', component: UsageDetails, name: 'UsageDetails', props: true },
                    { path: 'email', component: EmailPreviewDetails, name: 'EmailPreviewDetails', props: true }
                ]
            }
        ]
    }
];

export default routes;
